import { render, staticRenderFns } from "./dialog1.vue?vue&type=template&id=4d264aeb&scoped=true&"
import script from "./dialog1.vue?vue&type=script&lang=js&"
export * from "./dialog1.vue?vue&type=script&lang=js&"
import style0 from "./dialog1.vue?vue&type=style&index=0&id=4d264aeb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d264aeb",
  null
  
)

export default component.exports